export default __webpack_public_path__ + "0686bc016010cc4178579f174b56b32a.svg";